import React, { useState, useEffect } from 'react';

import PaySpinner from 'components/Core/Payment/PaySpinner/PaySpinner';
import Button from 'components/Shared/Button/Button';
import AffirmBnplButtonIcon from 'components/Shared/Icons/AffirmBnplButtonIcon';
import SegmentIO from 'reporting/SegmentIO';
import { breakpoints } from 'styles/cp';
import { Payment } from 'types/Payment';
import { TXN_MAP } from 'types/constants';

interface Props {
  className?: string;
  payment: Pick<Payment, 'isAmountValid' | 'paymentStatus'>;
  onAffirmBnplButtonClick: () => void;
}

const AffirmBnplBtn: React.FC<Props> = ({ payment, onAffirmBnplButtonClick }) => {
  const isPaymentInProgress = payment?.paymentStatus === TXN_MAP.STATUS.IN_PROGRESS;
  const isButtonDisabled = !payment?.isAmountValid || isPaymentInProgress;
  const [isAffirmBtnAnalyticsFired, setIsAffirmBtnAnalyticsFired] = useState(false);

  useEffect(() => {
    if (!isAffirmBtnAnalyticsFired) {
      SegmentIO.transactionViewed({
        activity_type: 'affirm_bnpl_render',
        ui_action: 'viewed',
        ui_object: 'button',
        ui_object_detail: 'affirm_bnpl_pay_button',
        ui_access_point: 'transaction_flow',
      });
      setIsAffirmBtnAnalyticsFired(true);
    }
  }, []);

  return (
    <div className="affirm-bnpl-btn-wrapper">
      <Button
        onClick={() => {
          onAffirmBnplButtonClick();
        }}
        disabled={isButtonDisabled}
        className="affirm-bnpl-btn"
        buttonType="affirm"
        size="responsive"
        width="100%"
        aria-label="Pay over time with Affirm"
      >
        {isPaymentInProgress ? (
          <PaySpinner paymentMethodType="affirm_bnpl" isIntuitThemeButton={false} />
        ) : (
          <AffirmBnplButtonIcon />
        )}
      </Button>
      <style jsx>{`
        .affirm-bnpl-btn-wrapper {
          margin-top: 24px;

          @media screen and (max-width: ${breakpoints.md}) {
            position: fixed;
            padding: 20px;
            z-index: 1098;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: white;
          }
        }
        .affirm-bnpl-btn-wrapper :global(.affirm-bnpl-btn) {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 48px;
          border-radius: 8px;
        }
      `}</style>
    </div>
  );
};

export default AffirmBnplBtn;
